import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetCexFeeRecordList } from "@/api";
import type { GetCexFeeRecordListResponse } from "@/api/types";
import { useUserStore } from "@/store/useUserStore";

const PAGE_SIZE = 20;

export function useGetCexFeeRecordList(enabled: boolean) {
  const { userInfo } = useUserStore();
  return useInfiniteQuery({
    queryKey: ["cexFeeRecordList"],
    queryFn: async ({ pageParam }): Promise<GetCexFeeRecordListResponse> => {
      const res = await ApiGetCexFeeRecordList({
        page: pageParam,
        pageSize: PAGE_SIZE,
      });
      console.log("useGetCexFeeRecordList", res.data);
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const fetched = allPages.reduce(
        (sum, page) => sum + (page.items?.length ?? 0),
        0
      );
      if (fetched >= (lastPage.total ?? 0)) return undefined;
      return allPages.length + 1;
    },
    enabled: enabled && !!userInfo?.address,
  });
}
